import React from 'react';
import { useFormikContext } from 'formik';

import Grid from '~/components/core/Atomic/Grid/Grid';
import { HierarchyFieldGroupPicker } from '~/components/IncidentConfiguration/HierarchyFieldGroup/HierarchyFieldGroupPicker';
import type { GroupValues } from '~/components/IncidentConfiguration/HierarchyFieldGroup/hierarchyTree';
import { usePolicy } from '~/components/PolicyContainer';
import type { FieldGroup } from '~/components/types/incident-configuration-types';

interface SectionFieldGroupPickersProps {
  fieldGroups: FieldGroup[];
  /** Claim page. Absent on FNOL, where the tree is identified by the policy the form holds. */
  claimId?: number;
}

/**
 * A section dialog's hierarchy groups. Both surfaces edit them inline, in the dialog's own Formik
 * beside the section's configured fields, and the dialog's save sends them with the section.
 */
const SectionFieldGroupPickers: React.FC<SectionFieldGroupPickersProps> = ({ fieldGroups, claimId }) => {
  const { values, setFieldValue } = useFormikContext<{ configured_fields_values?: Record<string, unknown> }>();
  const { policy } = usePolicy();

  if (fieldGroups.length === 0) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <Grid container spacing={1}>
        {fieldGroups.map((fieldGroup) => (
          <HierarchyFieldGroupPicker
            key={fieldGroup.id}
            fieldGroup={fieldGroup}
            values={values.configured_fields_values ?? {}}
            claimId={claimId}
            policy={claimId === undefined ? policy : undefined}
            inline
            onChange={(changedKeys: GroupValues) => {
              setFieldValue('configured_fields_values', { ...values.configured_fields_values, ...changedKeys });
            }}
          />
        ))}
      </Grid>
    </Grid>
  );
};

export default SectionFieldGroupPickers;
